import { render, staticRenderFns } from "./colors.vue?vue&type=template&id=40151761"
import script from "./colors.vue?vue&type=script&lang=js"
export * from "./colors.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports